import React from "react";
import { Container, Card } from "react-bootstrap";
import "./TermsOfUse.css";

// ─── セクションデータ（テキスト変更はここだけでOK）────────────────
const SECTIONS = [
  {
    id: "intro",
    heading: null,
    content: (
      <p className="terms-text">
        このWebサイト（https://www.zenkyo.co.jp/ 以下「当Webサイト」という）は、
        株式会社<span className="zenkyo-light">ZENKYO</span>（以下「弊社」という）が
        管理・運営しています。ご利用にあたっては以下の条件をご確認ください。
      </p>
    ),
  },
  {
    id: "copyright",
    heading: "1. 著作権",
    content: (
      <p className="terms-text">
        当Webサイト内のコンテンツ（文章・画像・音声・資料など）の著作権は弊社または提供者に帰属します。
        個人的利用または法律で認められた場合を除き、無断での複製・改変・配布・販売を禁じます。
      </p>
    ),
  },
  {
    id: "trademark",
    heading: "2. 商標",
    content: (
      <p className="terms-text">
        当Webサイト上の商標・ロゴマーク・商号は弊社の登録商標または商標です。
        法律により認められた場合を除き、無断使用はできません。
      </p>
    ),
  },
  {
    id: "accessibility",
    heading: "3. アクセシビリティ",
    content: (
      <p className="terms-text">
        弊社はWebアクセシビリティの確保に努め、障害の有無や高齢者を問わずサービス利用を可能にすることを目指します。
      </p>
    ),
  },
  {
    id: "environment",
    heading: "4. ご利用環境",
    content: (
      <>
        <p className="terms-text">
          推奨ブラウザ・OSは以下の通りです。タブレット・スマホでは端末標準ブラウザやメーカー拡張により
          一部機能が動作しない場合があります。
        </p>
        <ul className="terms-list">
          <li>Windows: Edge（最新版）、Chrome（最新版）、Firefox（最新版）</li>
          <li>MacOS: Safari（最新版）、Chrome（最新版）</li>
          <li>iOS: Safari（最新版）</li>
          <li>Android: Chrome（最新版）</li>
        </ul>
      </>
    ),
  },
  {
    id: "javascript",
    heading: "5. JavaScript",
    content: (
      <p className="terms-text">
        当WebサイトではJavaScriptを使用しています。
        無効の場合、コンテンツや機能が正しく表示されない場合があります。
      </p>
    ),
  },
  {
    id: "beacon",
    heading: "6. Webビーコン",
    content: (
      <p className="terms-text">
        アクセス解析のためGoogle Analyticsや統計ツールを利用しています。
      </p>
    ),
  },
  {
    id: "link",
    heading: "7. リンク",
    content: (
      <p className="terms-text">
        リンクは自由ですが、弊社Webサイトであることを明示してください。
        フレーム内で表示するなど誤解を与える表示は禁止です。弊社ロゴ使用は事前相談が必要です。
      </p>
    ),
  },
  {
    id: "disclaimer",
    heading: "8. 免責事項",
    content: (
      <p className="terms-text">
        コンテンツの正確性・安全性について保証せず、情報変更や中断による損害について責任を負いません。
        日本国内向けWebサイトのため、海外からの利用に関しても責任を負いません。
      </p>
    ),
  },
];

export default function TermsOfUse() {
  return (
    <div className="terms-page">
      <div id="page-top" />
      <Container className="py-5 d-flex justify-content-center">
        <Card className="shadow-lg p-5 rounded-4 terms-card">
          <h1 className="text-center mb-5 terms-title border-bottom pb-3">
            ご利用条件
          </h1>

          {SECTIONS.map(({ id, heading, content }) => (
            <section key={id} className="mb-4">
              {heading && <h2 className="terms-heading">{heading}</h2>}
              {content}
            </section>
          ))}
        </Card>
      </Container>
    </div>
  );
}
